// ============================================================================
// Clarification Feature - Field Utilities
// ============================================================================
// Utilities for entity type mapping (frontend ↔ backend) and field name
// formatting for display in the clarification UI.

export function mapEntityTypeToBackend(frontendType: string): string {
  return frontendType;
}

export function mapEntityTypeToFrontend(backendType: string): string {
  return backendType;
}

/**
 * Formats a camelCase field name into a human-readable "Title Case" label.
 *
 * Examples:
 *   "description" → "Description"
 *   "businessLogic" → "Business Logic"
 *   "technicalSources" → "Technical Sources"
 *   "name" → "Name"
 */
export function formatFieldName(fieldName: string): string {
  // Insert space before each uppercase letter, then capitalize first letter
  const spaced = fieldName.replace(/([A-Z])/g, " $1");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
